// extracted by mini-css-extract-plugin
export default {"resultCard":"ContraTestResultCard_resultCard__5pLm4","methodName":"ContraTestResultCard_methodName__VZanp","icon":"ContraTestResultCard_icon__Q+JSQ"};